import { render, staticRenderFns } from "./RateManagement.vue?vue&type=template&id=22e39758"
import script from "./RateManagement.vue?vue&type=script&lang=js"
export * from "./RateManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports